import { render, staticRenderFns } from "./generate-invoice-project.vue?vue&type=template&id=40585d97&"
import script from "./generate-invoice-project.vue?vue&type=script&lang=js&"
export * from "./generate-invoice-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports